import { OnDestroy } from "@angular/core";
import {
    Component,
    Input,
    OnInit,
    SimpleChanges,
    ViewChild,
    ViewContainerRef,
} from "@angular/core";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "department-header",
    templateUrl: "./department-header.component.html",
    standalone: false
})
export class _DepartmentHeaderComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBusService: EventBusService,
        private viewContainerRef: ViewContainerRef
    ) {}
    @ViewChild("deptHeaderTemplate", { static: true })
    deptHeaderTemplate;
    sub = new SubSink();
    buAccess: any;
    departments: any;

    uiDeptSettings: any;
    hasTalentDepartment = false;
    hasFinanceDepartment = false;
    hasPayrollDepartment = false;

    /*
      Add new timecardd
   * 
   */
    addNewTimecard() {
        //emit an event to add empty timecard to the db w.r.t. batch
        this._eventBusService.emit(
            new EmitEvent("addNewTimecard", "addNewTimecard", null)
        );
    }

    importNewTimecard() {
        //emit an event to add empty timecard to the db w.r.t. batch
        this._eventBusService.emit(
            new EmitEvent("importNewTimecard", "importNewTimecard", null)
        );
    }

    manipulateDeptAccess() {
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "APPROVER") {
                this.hasTalentDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "FINANCE") {
                this.hasFinanceDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "PAYROLL") {
                this.hasPayrollDepartment = true;
            }
        });
    }

    collapseDeptColumns(department) {
        this._eventBusService.emit(
            new EmitEvent(
                "collapseDeptColumns",
                "collapseDeptColumns",
                department
            )
        );
    }

    subscribeEventHandlers() {
        this.sub.sink = this._eventBusService.on(
            "uiDeptVisibilityChanged",
            (data) => {
                this.uiDeptSettings = data;
            }
        );

        this.sub.sink = this._eventBusService.on(
            "receiveBroadcastedMasterData",
            (data) => {
                this.buAccess = data.buAccess;
                this.departments = data.departments;
                this.manipulateDeptAccess();
            }
        );
    }

    //ngOnChanges(changes: SimpleChanges) {
    //  for (const propName in changes) {
    //    if (propName === 'departments') {
    //      let current = changes['departments']['currentValue'];
    //      if (current)
    //        this.manipulateDeptAccess();
    //    }
    //  }
    //}

    ngOnInit() {
        this.subscribeEventHandlers();
        this.viewContainerRef.createEmbeddedView(this.deptHeaderTemplate);
        setTimeout(
            () => this.viewContainerRef.element.nativeElement.remove(),
            100
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
